import { render, staticRenderFns } from "./LicenseStatus.vue?vue&type=template&id=1b8bf069&scoped=true&"
import script from "./LicenseStatus.vue?vue&type=script&lang=js&"
export * from "./LicenseStatus.vue?vue&type=script&lang=js&"
import style0 from "./LicenseStatus.vue?vue&type=style&index=0&id=1b8bf069&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8bf069",
  null
  
)

export default component.exports